<template>
    <div class="container">
        <b-container fluid v-show="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-show="showPage" style="margin-top:100px;">            
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Host interactions</h3>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <b-row>
                        <b-col style="align:left">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="filter"
                                    type="search"
                                    id="filterHmPairs"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row style="align:left">
                        <b-col>
                            <!-- <b-form-group 
                                label="Filter options"
                                label-for="filt-input">
                                <b-input-group>
                                    <b-form-select v-model="filtMod" :options="filtOptions"></b-form-select>
                                    <b-form-input id="filt-input" v-model="filtTerm"></b-form-input>
                                    <b-button variant="outline-primary" @click="addFilter">Add</b-button>
                                </b-input-group>
                            </b-form-group>
                            <div class="d-inline-block">                            
                            <ul>
                                <li v-for="(btn, idx) in addedFilters"
                                :key="idx" class="listyle">{{filtMap[btn.split(':')[0]]+':'+btn.split(':')[1]}} <a @click="removeFilter(btn)"><font-awesome-icon icon="window-close" size='sm'></font-awesome-icon></a> </li>
                            </ul>
                            </div> -->
                            <p>
                                <b>Note:</b>
                                The search box can be used to search Host name..
                            </p>
                            <p><download-csv
                            :data = "procSams" style="cursor: pointer;">
                        To download the filtered table data in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p>
                        </b-col>                        
                    </b-row>
                </b-col>
            </b-row>            
            <br/>
            <b-row>
                <b-col align-self="center">
                    <b-table
                                responsive
                                show-empty
                                :busy.sync="isBusy"
                                :striped="false"
                                :outlined="true"
                                :items="procSams"
                                :fields="tab_fields"
                                :current-page="currentPage"
                                :per-page="perPage"
                                :filter="filter"
                                :filter-function="filterTable"
                            >
                            <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                            </template>                            
                            <template v-slot:cell(show_details)="row">
                                <b-button size="sm" @click="toggleDetails(row)">
                                    {{ row.detailsShowing ? '-' : '+'}}
                                </b-button>
                            </template>
                            <template v-slot:cell(index)="data">
                                <span v-if="currentPage>1">{{ data.index + 1 +(currentPage*perPage)-perPage}}</span>
                                <span v-else>{{ data.index + 1 }}</span>
                            </template>
                            <template v-slot:cell(host)="row">
                            <a v-bind:href="'https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=' + row.item.taxonid" target="_blank">{{row.item.host}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                            </template>
                            <template v-slot:row-details="row">
                                <b-table
                                    sticky-header
                                    responsive
                                    show-empty
                                    :bordered="true"
                                    :busy.sync="row.item.loading"
                                    :striped="false"
                                    :outlined="true"
                                    :items="row.item.subarray"
                                    :fields="sub_tab_fields"                                    
                                >
                                    <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                                    </template>
                                    <template v-slot:cell(MGEs_id) ="row">
                                        <router-link :to="{ path: '/viewmge/'+row.item.MGEs_id.trim()}" target="_blank">{{row.item.MGEs_id.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                                    </template>
                                    <template v-slot:cell(MGEs_cluster) ="row">
                                        <span v-if="row.item.MGEs_cluster != 'singleton'">
                                            <router-link :to="{ path: '/viewcluster/'+row.item.MGEs_cluster.trim()}" target="_blank">{{row.item.MGEs_cluster.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                                        </span>
                                        <span v-else>
                                            {{row.item.MGEs_cluster.trim()}}
                                        </span>
                                    </template>
                                    <template v-slot:cell(completeness) ="row">
                                        <span v-if="row.item.completeness != null && row.item.completeness != 'NULL' && row.item.Genome_quality.length >1">
                                            {{(row.item.completeness)}}
                                        </span>
                                        <span v-else>
                                            NA
                                        </span>
                                    </template>
                                    <template v-slot:cell(Genome_quality) ="row">
                                        <span v-if="row.item.Genome_quality != null && row.item.Genome_quality != 'NULL' && row.item.Genome_quality.length >1">
                                            {{row.item.Genome_quality}}
                                        </span>
                                        <span v-else>
                                            NA
                                        </span>
                                    </template>
                                    <template v-slot:cell(taxonid) ="row">
                                        <span v-if="row.item.taxonid != null && row.item.taxonid != 'NULL'">
                                            <a v-bind:href="'https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id='+row.item.taxonid" target="_blank">{{row.item.taxonid}}<font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a> 
                                            <!-- <router-link :to="{ path: '/viewproject/'+row.item.ProjectID.trim()}" target="_blank" v-b-tooltip.hover title="View Project details in our database">{{row.item.ProjectID.trim()}} <font-awesome-icon icon="link" size='sm'></font-awesome-icon></router-link> -->
                                            <!-- <b-badge id="badge-tar" variant="primary"><a v-bind:href="'https://www.ncbi.nlm.nih.gov/bioproject/' + row.item.NCBI_Run_ID.trim()" target="_blank" style="color:white">NCBI <font-awesome-icon icon="external-link-alt" size='sm'></font-awesome-icon></a></b-badge> -->
                                        </span>
                                        <span v-else>
                                            unknown
                                        </span>
                                    </template>
                                    <template v-slot:cell(host_range) ="row">
                                        <span v-if="row.item.host_range != null && row.item.host_range != 'NULL'">
                                            {{row.item.host_range}}
                                        </span>
                                        <span v-else>
                                            unknown
                                        </span>
                                    </template>
                                </b-table>                                
                            </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="procSamsSize"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <br> <br>
            <b-row style="text-align:left">
                <b-col>
                    <h4>Network visualization (of randomly selected interations)</h4>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div id="boxBg">
                        <p>
                            <font-awesome-icon icon="exclamation-triangle" size='sm'></font-awesome-icon>&nbsp;Note:
                            <ul>
                            <li>Due to performance issues we cannot display the whole network with more than ten thousands of connections.</li>
                            <li>The plot will be replotted with new data each time the page is hard-refreshed (i.e. refresh with the browser's "Refresh" button).</li>
                            <li>Please contact the authors if you wish to have a visualization containing all (available) interactions.</li>
                            <li>User can select different host from the dropdown menu and view both their individual eMGEs connections with host and also view shared eMGE connections while selecting more than one host.</li>
                            </ul>
                        </p>
                        <p>
                            <font-awesome-icon icon="exclamation-circle" size='sm'></font-awesome-icon>&nbsp;color codes:
                            <ul>
                            <li>Sandal circle: eMGEs(phage/plasmid) associated with Host (in our database);</li>
                            <li>greenish circle: Host that associates with multiple eMGEs (in our database);</li>
                            </ul>
                        </p>
                        <p>
                            <font-awesome-icon icon="lightbulb" size='sm' style="color:yellow"></font-awesome-icon>&nbsp;Tips:
                            <ul>
                                <li><span style="color:red">mouse over a node</span>  to a) highlight the node and its direct neighbors, b) show the names of the node and its direct neighbors;</li>
                                <li><span style="color:red">double-click the canvas </span>to zoom in;</li>
                                <li><span style="color:red">use mouse wheel</span> to zoom in and out of the whole plot</li>
                            </ul>
                        </p>
                    </div>
                </b-col>
            </b-row>
            <br>
            <b-row>
                <!-- <b-col cols="11" style="text-align: left">
                    <b-form-group label="Select cluster group" label-for="selnode">
                    </b-form-group>
                    <b-form-select id="selnode" v-model="selNodeMod" :options="nodeModeOptions"></b-form-select>
                </b-col>
                <b-col cols="1"></b-col> -->
                <b-col>
                    <!-- <model-select :options="nodeModeOptions"
                                    v-model="selNodeMod"
                                    placeholder="find host by name"
                                    @input="loadSelNetwork"
                                    >
                    </model-select> -->
                    <multiselect 
                                v-model="selNodeMod" 
                                :options="nodeModeOptions"                                
                                track-by="text" label="text"
                                @input="loadSelNetwork"
                                @close="reloadSelNetwork"
                                :multiple="true"
                    ></multiselect>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                        <svg id="viz" style="width:100%;height:550px;border-style: outset;"></svg>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
const _ = require("underscore")
import * as d3 from 'd3'
// import jsonData from '../assets/network_sep21.json'
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelSelect } from 'vue-search-select'
// import GenNetwork from './GenNetwork'
// import jsonNetData from '../assets/interNetwork.json'


export default {
    components:{
        // ModelSelect
    },
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            showPage:true,
            filter:null,
            isBusy:true,
            tab_data:[],
            tab_fields:[
                { key:'show_details',label: '','class': 'small_col2'},
                { key: 'index', label: 'S.No', sortable: false ,'class': 'medium_col'},
                { key: 'taxonid', label: 'Taxon Id', sortable: true},
                { key: 'host', label: 'Host', sortable: true},
                { key: 'totalmge', label: 'No. of Interactions', sortable: true},
            ],
            sub_tab_fields:[
                { key:'MGEs_id',label:'eMGE ID',sortable:false },
                { key: 'status', label: 'Type', sortable: false },
                { key: 'MGEs_cluster', label: 'eMGE cluster', sortable: true},
                { key: 'sample_count', label: 'Samples', sortable: true},
                { key: 'gene_number', label: 'Gene number', sortable: true},
                // { key: 'TaxonId', label: 'Taxon Id', sortable: true},
                { key: 'host_range', label: 'Host range', sortable: false},
                { key: 'contig_length', label: 'Length', sortable: true},
                { key: 'structure', label: 'Structure', sortable: true},
                { key: 'completeness', label: 'Completeness', sortable: false},
                { key: 'Genome_quality', label: 'Quality', sortable: false},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [5, 10, 15,25],
            projHtmlTxt:'',
            filtMod:'Country',
            filtTerm:'',
            filtOptions:['Country','Related disease'],
            filtMap:{'Country':'Country','RelatedDisease':'Related disease','Related disease':'RelatedDisease'},
            addedFilters:[],
            selNodeMod:[],
            baseUrl: process.env.VUE_APP_BASE_URL,
            nodeModeOptions:[],
            selNodes:[],
            genDNetwork:null,
        }
    },
    mounted() {
        this.loadProjTab()
        this.loadNetorkJsonFile(['/json/Shewanella(genus level)_host.json']) //Shewanella(genus level)
    },
    computed: {
        procSams(){
            if(this.tab_data.length){
                let tem = this.tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.filter != null && this.filter.length>=1){
                        // console.log(filter)
                        var sup = this.filter                                        
                        if( (sam.hostName != null && sam.hostName.match(sup)) ||
                         (sam.taxonId != null && sam.taxonId.match(sup))){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem
            }
            return []
        },
        procSamsSize(){
            if(this.tab_data.length){
                let tem = this.tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.filter != null && this.filter.length>=1){
                        // console.log(filter)
                        var sup = this.filter                                        
                        if( (sam.hostName != null && sam.hostName.match(sup)) ||
                         (sam.taxonId != null && sam.taxonId.match(sup))){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem.length
            }
            return 0
        }
    },
    methods: {
        loadSelNetwork(actionName){
            // console.log(this.selNodeMod,actionName)
            var json_ar = actionName.map(p=>'/json/'+p.value+'_host.json')
            // let host_json = '/json/'+actionName.value+'_host.json'
            this.loadNetorkJsonFile(json_ar)
        },
        reloadSelNetwork(){
            if(this.selNodeMod.length<=0){
                this.loadNetorkJsonFile(['/json/Shewanella(genus level)_host.json']) //Shewanella(genus level)
            }
        },
        loadNetorkJsonFile(file_name_ar){
            var prom_ar = []
            var nodes = []
            var links = []
            file_name_ar.forEach(element => {
                prom_ar.push(axios.get(element))
            });
            var that = this
            Promise.all(prom_ar).then(function(values) {
                values.forEach(element => {
                    let json = element.data
                    nodes = that.arrayUnique(nodes.concat(json.nodes))
                    links = links.concat(json.links)
                    console.log(json)
                });
                var json = {
                    'nodes':nodes,
                    'links':links
                }
                console.log(json)
                that.loadNetworkGraph(json)
            });            
        },
        arrayUnique(array) {
            var a = array.concat();
            for(var i=0; i<a.length; ++i) {
                for(var j=i+1; j<a.length; ++j) {
                    if(a[i] === a[j])
                        a.splice(j--, 1);
                }
            }
            return a;
        },
        loadNetworkGraph(jsonData){
            let width = 600
            let height = 550
            d3.select('#viz').selectAll('*').remove();
            // let svg = d3.select('#viz').attr('width', width).attr('height', height)
            // this.genDNetwork =  new GenNetwork(svg)
            let color = d3.scaleOrdinal(d3.schemeCategory10)
            let graph = jsonData
            let label = {
            'nodes': [],
            'links': []
            }
            let linkedByIndex = {}
            graph.nodes.forEach(function (d, i) {
            label.nodes.push({ node: d })
            label.nodes.push({ node: d })
            label.links.push({
                source: i * 2,
                target: i * 2 + 1
            })
            })
            label.links.forEach(function (d) {
                linkedByIndex[d.source + "," + d.target] = true;
            });
            var that = this            
            let labelLayout = d3.forceSimulation(label.nodes)
            .force('charge', d3.forceManyBody().strength(-50))
            .force('link', d3.forceLink(label.links).distance(0).strength(2))
            d3.forceSimulation(graph.nodes)
            .force('charge', d3.forceManyBody().strength(-3000))
            .force('center', d3.forceCenter(width / 2, height / 2))
            .force('x', d3.forceX(width / 2).strength(1))
            .force('y', d3.forceY(height / 2).strength(1))
            .force('link', d3.forceLink(graph.links).id(function (d) { return d.id }).distance(50).strength(1))
            .on('tick', ticked)
            let adjlist = []
            graph.links.forEach(function (d) {
            adjlist[d.source.index + '-' + d.target.index] = true
            adjlist[d.target.index + '-' + d.source.index] = true
            })
            function neigh (a, b) {
            return a === b || adjlist[a + '-' + b]
            }
            let svg = d3.select('#viz').attr('width', width).attr('height', height)
            let container = svg.append('g')
            var focus_node = null, highlight_node = null;
            svg.call(
            d3.zoom()
                .scaleExtent([.1, 4]) // eslint-disable-line
                .on('zoom', function () {
                container.attr('transform', d3.event.transform)
                })
            )
            let link = container.append('g').attr('class', 'links')
            .selectAll('line')
            .data(graph.links)
            .enter()
            .append('line')
            .attr('stroke', '#aaa')
            .attr('stroke-width', '1px')
            let node = container.append('g').attr('class', 'nodes')
            .selectAll('g')
            .data(graph.nodes)
            .enter()
            .append('circle')
            .attr('r', function (d) { return d.sz})
            .attr('fill', function (d) { return getColor(d) })

            let labelNode = container.append('g').attr('class', 'labelNodes')
            .selectAll('text')
            .data(label.nodes)
            .enter()
            .append('text')
            .text(function (d, i) { return i % 2 === 0 ? '' : d.node.id })
            .style('fill', '#555')
            .style('font-family', 'Arial')
            .style('font-size', 12)
            .style('pointer-events', 'none')
            .attr('display','none')

            node.on('mouseover', focus).on('mouseout', unfocus)
            // node.on('click',focus)

                            
            function ticked () {
                node.call(updateNode)
                link.call(updateLink)
                labelLayout.alphaTarget(0.3).restart()
                labelNode.each(function (d, i) {
                    if (i % 2 === 0) {
                        d.x = d.node.x
                        d.y = d.node.y
                    } else {
                        let b = this.getBBox()
                        let diffX = d.x - d.node.x
                        let diffY = d.y - d.node.y
                        let dist = Math.sqrt(diffX * diffX + diffY * diffY)
                        let shiftX = b.width * (diffX - dist) / (dist * 2)
                        shiftX = Math.max(-b.width, Math.min(0, shiftX))
                        let shiftY = 16
                        this.setAttribute('transform', 'translate(' + shiftX + ',' + shiftY + ')')
                    }
                })
                labelNode.call(updateNode)
            }
            function fixna (x) {
                if (isFinite(x)) return x
                return 0
            }
            function isConnected(a, b) {
                    return linkedByIndex[a.index + "," + b.index] || linkedByIndex[b.index + "," + a.index] || a.index == b.index;
            }        
            function focus () {
                let index = d3.select(d3.event.target).datum().index
                node.style('opacity', function (o) {
                    return neigh(index, o.index) ? 1 : 0.1
                })
                labelNode.attr('display', function (o) {
                    return neigh(index, o.node.index) ? 'block' : 'none'
                })
                link.style('opacity', function (o) {
                    return o.source.index === index || o.target.index === index ? 1 : 0.1
                })
            }
            function unfocus () {
                labelNode.attr('display', 'none')
                node.style('opacity', 1)
                link.style('opacity', 1)
            }
            function updateLink (link) {
            link.attr('x1', function (d) { return fixna(d.source.x) })
                .attr('y1', function (d) { return fixna(d.source.y) })
                .attr('x2', function (d) { return fixna(d.target.x) })
                .attr('y2', function (d) { return fixna(d.target.y) })
            }
            function updateNode (node) {
                node.attr('transform', function (d) {
                    // console.log(fixna(d.x) + ' , ' + fixna(d.y))
                    return 'translate(' + fixna(d.x) + ',' + fixna(d.y) + ')'
                })
            }
            function getColor(nod){
                switch(nod.type){
                    case 'phage': return d3.rgb(252,141,98);
                    case 'plasmid': return d3.rgb(55,102,102);
                    case 'possible_plasmid': return d3.rgb(55,102,102);
                    case 'possible_phage': return d3.rgb(252,141,98);
                    case 'host': return d3.rgb(102,194,165);
                    case 'unknown': return 'darkOrange';
                }
            return 'darkOrange'
            }
        },
        loadProjTab(){
            axios.post(this.server_add+'query/getInteractions',
            {
            }).then(retDat => {
                if(retDat.status == 200){
                    this.tab_data = retDat.data
                    this.showPage = true
                    this.isBusy = false
                    this.totalRows = this.tab_data.length
                    this.tab_data.forEach(element => {
                        this.nodeModeOptions.push({text:element.host+"(eMGEs:"+element.totalmge+")",value:element.host})
                    });
                }
            }).catch(err => {
                console.log(err)
            })
        },
        toggleDetails(item) {
            item.toggleDetails()
            // var url = this.server_add+'query/getHostMGEs?mgeid='+item.item.sub_keys
            if (item.item.subarray.length>=1) { // if details already exists, show the details
                // this.$set(item.item, '_showDetails', true)
                                // fetch(`${url}`)
            }else{
                // console.log(url)
                axios.post(this.server_add+'query/getHostMGEs',
                {
                    mgeid:item.item.sub_keys
                })
                .then(response => {
                    item.item.subarray = response.data
                    item.item.loading = false;
                    item.item.subDisplayed = true
                })
            }
        },
        filterTable(row,filter) {
            var hasAss = false
            if(filter.includes(row.NCBIProjectID) || filter.includes(row.Country) || filter.includes(row.RelatedDisease)){
                hasAss = true
            }
            if(filter != null ){
                var su = filter.trim()
                if( (row.NCBIProjectID != null && row.NCBIProjectID.match(su)) || 
                (row.Country != null && row.Country.match(su)) || 
                (row.RelatedDisease != null && row.RelatedDisease.match(su)) ){
                  hasAss = true
                }
            }
            return hasAss;            
        },        
        addFilter(){
            var filtType = this.filtMap[this.filtMod]
            var filtText = this.filtTerm
            var res = filtType+":"+filtText
            if(!this.addedFilters.includes(res)){
                this.addedFilters.push(res)
                this.filtTerm = ''
            }
        },
        removeFilter(term){
            var ind = this.addedFilters.indexOf(term)
            if(ind >-1){
                this.addedFilters.splice(ind, 1);
            }
        },
    },
}
</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}

.medium_col{
  width: 160px !important;
  height: 25px !important;
  max-height: 25px !important;
  max-width: 160px !important;
  text-align: center;
}
</style>